webpackJsonp([265084189438422],{

/***/ 1360:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Speech Recognition in the Browser","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/speech-recognition-in-the-browser","createdAt":"2015-09-15T04:36:06.765Z","blogAuthor":{"fields":{"name":"Jakub Jedryszek","slug":"blog/author/jakub-jedryszek"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/2OOdxTA7CMus4IYA2ak00y/a940c7f7457ff21e7d89e56fe5c8788f/blog-post-blog-speech-recognition-in-the-browser.png"}}}}}]},"authorJson":{"name":"Jakub Jedryszek","slug":"blog/author/jakub-jedryszek","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/jakub-jedryszek"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-jakub-jedryszek-fb5302b0fd13e4d7f604.js